import { z } from 'zod';

export const cancelEventSchema = z.object({
  notifyGuests: z.boolean().default(false),
  emailNotification: z.boolean().default(false),
  slackNotification: z.boolean().default(false),
  slackMessage: z.string().nullable().default(null)
});

export type CancelEventFormValues = z.infer<typeof cancelEventSchema>;
